import { IoMdClose } from 'react-icons/io';

import styled from 'styled-components';
import { _flex, _grid } from 'theme/_mixins/mixins';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.filters.background};
`;

export const Content = styled.div`
  flex: 1;
  height: 100%;
  padding: 55px 0 60px;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0 0 70px;
  }
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border-bottom: 1px solid ${ColorPalette.HEX.Cultured};
  padding: 20px 0 16px;
  width: 100%;
  background: ${ColorPalette.HEX.White};
  margin: -17px 0 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;

Header.Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  line-height: normal;
  text-align: center;
  margin: 0 auto;
`;

export const Close: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
Close.Icon = styled(IoMdClose)`
  font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
`;

interface FieldProps {
  columns?: number;
  isFlex?: boolean;
}

export const Fields = styled.ol`
  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 80px;
  }
`;

export const Field: any = styled.li<FieldProps>`
  ${({ columns, isFlex }) => (isFlex ? _flex() : _grid({ gap: 8, columns }))};
  margin: 8px 0;
`;

Field.Label = styled.label`
  padding: 0;
  display: flex;
  align-items: center;
  &.search-tvl-id {
    width: 33.33%;
  }
`;
Field.Input = styled.div``;

export const SearchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    margin-bottom: 32px;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  width: 50%;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 28px 16px 0px;
    width: 100%;
  }
`;
